export const DAEMON = '@@sagaInjector/DAEMON'
export const ONCE_TILL_UNMOUNT = '@@sagaInjector/ONCE_TILL_UNMOUNT'
